// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--e7e28";
export var accordionIcon = "styles-module--accordion-icon--5b2e4";
export var accordionTitle = "styles-module--accordion-title--6194e";
export var active = "styles-module--active--6efc7";
export var bodyContent = "styles-module--bodyContent--febfb";
export var bodySection = "styles-module--bodySection--23668";
export var cardTitles = "styles-module--cardTitles--76702";